







































































import Vue from "vue";
import router from './router';
import Antd from 'ant-design-vue';
import "ant-design-vue/dist/antd.css";
import CookieLaw from 'vue-cookie-law';

const stepIndexToRouteName = [
  "restaurantparameter",
  "umsatzplanung",
  "personaleinsatz",
  "ergebnis",
];

export default Vue.extend({
  data() {
    return {
      stepId: -1,
      maxStepId: 0,
    }
  },
  created: function() {
    if (router.currentRoute.name && router.currentRoute.name !== "") {
      this.stepId = stepIndexToRouteName.indexOf(router.currentRoute.name);
    } else {
      this.stepId = -1;
    }
    this.maxStepId = Math.max(this.maxStepId,this.stepId);
  },
  components: {
    CookieLaw
  },
  name: "Wiedereröffnungstool",
  methods: {
    onChange: function(stepId:any) {
      if (stepId <= this.maxStepId) {
        this.navToStepId(stepId);
      }
    },
    navToStepId: function(stepId:number) {
      router.push(stepIndexToRouteName[stepId]);
      window.scrollTo(0,0);
    },
    onNextClick: function() {
      this.navToStepId(this.stepId + 1);
    },
    onPreviousClick: function() {
      this.navToStepId(this.stepId - 1);
    },
    onAcceptCookies: function() {
      this.$ga.enable();
    },
    onDeclineCookies: function() {
      this.$ga.disable();
      (this.$refs.cookieBanner as any).close();
    },
  },
  watch: {
    $route(to, from) {
      if (to.name && to.name !== "") {
        this.stepId = stepIndexToRouteName.indexOf(to.name);
      } else {
        this.stepId = -1;
      }
      this.maxStepId = Math.max(this.maxStepId,this.stepId);
    }
}
});
